module.exports = __webpack_public_path__ + "media/images/svgs/jobs/cooking-18f99583ed768c8cc836f632a2372ec5.svg";